import moment from "moment";
import dayjs from "dayjs";
//report crm
//startDate, endDate สลับกัน
//startDate <= endDate เท่านั้น
export const getDateRange = (type, filterDay) => {
  const startDate =
    type === "Today"
      ? dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss ")
      : dayjs(filterDay.endDate).format("YYYY-MM-DD");

  const endDate =
    type === "Today"
      ? dayjs().endOf("day").format("YYYY-MM-DD HH:mm")
      : dayjs(filterDay.startDate).format("YYYY-MM-DD");

  return { startDate, endDate };
};

export const extractTime = (dateTime: string): string => {
  const time = dateTime.split(" ")[1];
  return time;
};
